import React from "react";

import PropTypes from "prop-types";

import { InputMask } from "primereact/inputmask";
import { InputText } from "primereact/inputtext";

import MaskUtil from "utils/MaskUtil";
import { validarCPF } from "utils/ValidacaoUtils";

import { useNotification } from "context/NotificationContext";

import { Dropdown } from "primereact/dropdown";
import bancos from 'data/bancos'; // Ajuste o caminho conforme necessário
import EnderecoFuncionario from "components/RH/inputs/EnderecoFuncionario";

const DadosColaborrador = ({
  dados,
  setDados,
  HandleChange,
  errors = {},
  obrigatorios = []
}) => {
  const notify = useNotification();

  const isRequired = (campo) => obrigatorios.includes(campo);
  const isError = (campo) => errors && errors[campo];

  const handleCPFChange = (e) => {
    const cpfValue = e.target.value;
    setDados(prev => ({ ...prev, cpf: cpfValue }));
  };

  const handleCPFBlur = (e) => {

    const cpfValue = e.target.value.replace(/\D/g, '');
    if (cpfValue.length === 11) {
      if (!validarCPF(cpfValue)) {
        notify({
          type: "error",
          message: "CPF inválido. Por favor, verifique."
        });
        setTimeout(() => {
          e.target.focus(); // Foca novamente no campo CPF se não for válido
        }, 100);
      }
    } else {
      notify({
        type: "error",
        message: "CPF inválido. Por favor, verifique."
      });
      setTimeout(() => {
        e.target.focus(); // Foca novamente no campo CPF se não for válido
      }, 100);
    }
  };

  return (
  <div className="row g-3">
    <div className="col-md-6 col-lg-3">
      <label htmlFor="nome" className="form-label">
        Nome Completo{isRequired("nome") && <span className="text-danger">*</span>}
      </label>
      <InputText
        id="nome"
        name="nome"
        value={dados.nome}
        onChange={HandleChange}
        className={`form-control${isError("nome") ? " is-invalid" : ""}`}
      />
      {isError("nome") && <div className="invalid-feedback">Obrigatório</div>}
    </div>
    <div className="col-md-6 col-lg-3">
      <label htmlFor="cpf" className="form-label">
        CPF{isRequired("cpf") && <span className="text-danger">*</span>}
      </label>
      <InputMask
          id="cpf"
          name="cpf"
          value={dados.cpf}
          onChange={handleCPFChange}
          onBlur={handleCPFBlur}
          mask="999.999.999-99"
          unmask={false} // Mantenha isso como false para manter os pontos e traços na entrada
          className={`form-control${isError("cpf") ? " is-invalid" : ""}`}
          placeholder="000.000.000-00"
          autoClear={false}
        />
      {isError("cpf") && <div className="invalid-feedback">Obrigatório</div>}
    </div>
    <div className="col-md-6 col-lg-3">
      <label htmlFor="rg" className="form-label">
        RG{isRequired("rg") && <span className="text-danger">*</span>}
      </label>
      <InputText
        id="rg"
        name="rg"
        value={dados.rg}
        onChange={(e) =>
          setDados({
            ...dados,
            rg: MaskUtil.applyRgMask(e.target.value)
          })
        }
        className={`form-control${isError("rg") ? " is-invalid" : ""}`}
      />
      {isError("rg") && <div className="invalid-feedback">Obrigatório</div>}
    </div>
          <div className="col-md-6 col-lg-3">
        <label htmlFor="email" className="form-label">
          Email{isRequired("email") && <span className="text-danger">*</span>}
        </label>
      <InputText
        id="email"
        name="email"
        value={dados.email}
        onChange={HandleChange}
        className={`form-control${isError("email") ? " is-invalid" : ""}`}
      />
      {isError("email") && <div className="invalid-feedback">Obrigatório</div>}
    </div>
    <div className="col-md-6 col-lg-3">
      <label htmlFor="telefone" className="form-label">
        Telefone{isRequired("telefone") && <span className="text-danger">*</span>}
      </label>
      <InputText
        id="telefone"
        name="telefone"
        value={dados.telefone}
        onChange={(e) =>
          setDados({
            ...dados,
            telefone: MaskUtil.applyTelefoneMask(e.target.value)
          })
        }
        className={`form-control${isError("telefone") ? " is-invalid" : ""}`}
      />
      {isError("telefone") && <div className="invalid-feedback">Obrigatório</div>}
    </div>
    <div className="col-md-6 col-lg-3">
      <label htmlFor="banco" className="form-label">
        Banco{isRequired("banco") && <span className="text-danger">*</span>}
      </label>
      <Dropdown
        value={dados.banco}
        options={bancos}
        onChange={(e) => {
          setDados(prev => ({
            ...prev,
            banco: e.value
          }));
        }}
        optionLabel="nome"
        optionValue="codigo"
        placeholder="Selecione um banco"
        id="banco"
        name="banco"
        className={`p-dropdown w-100${isError("banco") ? " is-invalid" : ""}`}
      />
      {isError("banco") && <div className="invalid-feedback">Obrigatório</div>}
    </div>
    <div className="col-md-6 col-lg-3">
      <label htmlFor="agencia" className="form-label">
        Agência{isRequired("agencia") && <span className="text-danger">*</span>}
      </label>
      <InputMask
        id="agencia"
        name="agencia"
        value={dados.agencia}
        onChange={HandleChange}
        className={`form-control${isError("agencia") ? " is-invalid" : ""}`}
        mask="9999"
      />
      {isError("agencia") && <div className="invalid-feedback">Obrigatório</div>}
    </div>
    <div className="col-md-6 col-lg-3">
      <label htmlFor="contaCorrente" className="form-label">
        Número da Conta Corrente{isRequired("contaCorrente") && <span className="text-danger">*</span>}
      </label>
      <InputMask
        id="contaCorrente"
        name="contaCorrente"
        value={dados.contaCorrente}
        onChange={HandleChange}
        className={`form-control${isError("contaCorrente") ? " is-invalid" : ""}`}
        mask="9999999-9"
              />
        {isError("contaCorrente") && <div className="invalid-feedback">Obrigatório</div>}
      </div>

      {/* Seção de Endereço */}
      <div className="col-12">
        <hr className="my-4" />
        <h5 className="mb-3">
          <i className="pi pi-map-marker me-2" />
          Endereço
        </h5>
        <EnderecoFuncionario
          dados={dados}
          setDados={setDados}
          errors={errors}
          obrigatorios={["cep", "logradouro", "numero", "bairro", "cidade", "estado"]}
        />
      </div>
    </div>
  )};

DadosColaborrador.propTypes = {
  dados: PropTypes.shape({
    nome: PropTypes.string.isRequired,
    cpf: PropTypes.string.isRequired,
    rg: PropTypes.string.isRequired,
    cep: PropTypes.string,
    logradouro: PropTypes.string,
    numero: PropTypes.string,
    complemento: PropTypes.string,
    bairro: PropTypes.string,
    cidade: PropTypes.string,
    estado: PropTypes.string,
    telefone: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    banco: PropTypes.string.isRequired,
    agencia: PropTypes.string.isRequired,
    contaCorrente: PropTypes.string.isRequired
  }).isRequired,
  HandleChange: PropTypes.func.isRequired,
  setDados: PropTypes.func.isRequired,
  errors: PropTypes.objectOf(PropTypes.bool),
  obrigatorios: PropTypes.arrayOf(PropTypes.string)
};

DadosColaborrador.defaultProps = {
  errors: {},
  obrigatorios: []
};

export default DadosColaborrador;
